﻿import { Dictionary } from "../../Utilities/index";

// eslint-disable-next-line @typescript-eslint/no-extraneous-class
export class PointerEventsManager {
    private static readonly _watchers: Dictionary<
        string,
        (events: boolean) => void
    > = new Dictionary();

    public static registerWatcher(
        key: string,
        watcherCallback: (events: boolean) => void,
    ): void {
        PointerEventsManager._watchers.push(key, watcherCallback);
    }

    public static deRegisterWatcher(key: string): void {
        PointerEventsManager._watchers.remove(key);
    }

    public static togglePointerEvents(toggle: boolean): void {
        PointerEventsManager._watchers.forEach(
            (key: string, value: (events: boolean) => void): void => {
                value(toggle);
            },
        );
    }
}
